<template>
  <div>
    <van-cell-group>
      <van-field v-model.trim="nickName" placeholder="请输入昵称" maxlength="20" autofocus clearable />
    </van-cell-group>
    <br />
    <p class="tips width-351">支持汉字、数字、字母，最多20字</p>
    <van-button color="#1E8DFF" block :disabled="!nickName" class="width-351" @click="save">保 存</van-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'NickName',
  // props: {},
  data() {
    return {
      nickName: ''
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    'userInfo.nickName': {
      handler(val) {
        this.nickName = val;
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    save() {
      let params = {
        nickName: this.nickName
      };
      var pattern = /^[\w\u4e00-\u9fa5]+$/gi;
      if (!pattern.test(this.nickName)) {
        this.$toast('昵称中含有特殊字符，请修改');
        return;
      }
      this.$fetch.fetchModifyUserInfo(params).then(() => {
        this.$toast.success('保存成功');
        setTimeout(() => {
          this.getUserInfo();
          this.$router.go(-1);
        }, 3000);
      });
    }
  }
};
</script>

<style scoped>
.tips {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 40px;
}
.van-cell-group {
  margin-top: 10px;
}
</style>
